import React, { useEffect } from "react";
import { Layout } from "components";
import { useNavigate, useLocation } from "react-router-dom";
import { HomeButton } from "components/CommonUI";
import moment from "moment";
import { FULL_DATE_TIME_FORMAT } from "constants/date";

export default function CancelSuccess() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { transTime } = state; // Read values passed on state

  // const onBackButtonEvent = () => {
  //   window.history.pushState(null, null, window.location.pathname);
  // };

  // useEffect(() => {
  //   window.addEventListener("popstate", onBackButtonEvent());
  // });

  return (
    <Layout subHeader={"How can we help?"}>
      <div className="form-box">
        <div className="center fw-bold text-secondary mt-3">
          <i class="icon-dls-tick-solid icon-big"></i>
          <h3>Your appointment is cancelled</h3>
        </div>

        <div
          style={{
            marginLeft: 10,
            marginRight: 10,
            textAlign: "center",
            marginTop: 50,
            marginBottom: 50
          }}
        >
          Your appointment has been cancelled.
          <br /> We will send you a confirmation message shortly.
          <br />
          To make a new appointment, click on "Back to contact us" below.
        </div>
        <div style={{ marginLeft: 20 }} className="trans-date">
          {/* Transaction Date : 06 Jul 2022 11:17 AM */}
          Transaction Date : {moment(transTime).format(FULL_DATE_TIME_FORMAT)}
        </div>
        <div className="form-footer">
          <HomeButton />
        </div>
      </div>
    </Layout>
  );
}
